// Do not sort CSS files.

import 'ol/ol.css'
import 'css/index.css'
import 'css/add-feature.css'
import 'css/fragments.css'
import 'css/go.css'
import 'css/login.css'
import 'css/main.css'
import 'css/measure.css'
import 'css/print.css'
import 'css/widget.css'
import 'css/auth.css'
import 'material-design-lite'
import 'global.d' // This is where global variables get declared

import React, { Suspense, lazy } from 'react'

import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux'
import { reduxStore } from 'reduxStore'

import { doMsal } from 'config/msalUtils'

// import AppWrapper from 'app/AppWrapper'
// import WidgetWrapper from 'widget/WidgetWrapper'

// Prevent initialisation multiple times in development (HMR)
let initalised = false

if (!initalised) {
  const AppWrapper = lazy(() => import('app/AppWrapper'))
  const WidgetWrapper = lazy(() => import('widget/WidgetWrapper'))

  // Initialise Microsoft Azure Libraryt (MSAL)
  await doMsal()

  // Make the redux store globally available
  // TODO: remove this one day
  window.store = reduxStore

  // We'll load either the App or Widget here
  const appInfo = window.getAppInfo()
  const isWidget = appInfo.mode === 'widget'

  const Wrapper = isWidget ? WidgetWrapper : AppWrapper
  const renderElementId = isWidget ? 'widget-search-box' : 'root'

  const renderElement = document.getElementById(renderElementId) as HTMLElement

  const indexComponent = (
    <Provider store={reduxStore}>
      <Suspense fallback={<span />}>
        <Wrapper />
      </Suspense>
    </Provider>
  )

  const root = createRoot(renderElement)
  root.render(indexComponent)

  initalised = true
} else {
  console.log('index - Already initalised')
}
